@if (dataContext) {
  <div class="astral-form-stack">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <app-autocomplete-remote [control]="form.controls['tenantOne']" [service]="dataService"></app-autocomplete-remote>
      @if (tenantOneHasCivic) {
        <astral-input
          [label]="tenantOneIdType"
          [value]="tenantOneCivic"
          [readonly]="true"
          [helpText]="'TENANT.HELP_TEXT.OPEN_TENANT'"
        ></astral-input>
      }
      @if (tenantOneHasPhone) {
        <astral-input
          label="TENANT.PHONE"
          [value]="tenantOnePhone"
          [readonly]="true"
          [helpText]="'TENANT.HELP_TEXT.OPEN_TENANT'"
          [type]="'phone'"
          [inputMode]="'tel'"
        ></astral-input>
      }
      @if (tenantOneHasEmail) {
        <astral-input [control]="tenantOneEmailControl" [type]="'email'" [inputMode]="'email'"></astral-input>
      }
      @if (tenantOneExist) {
        <div class="create-button astral-link-action astral-form-adjacent-action">
          <astral-button variant="link-button" type="button" labelKey="COMMON.OPEN_CONTACT" (click)="onOpenTenantOneClicked()"></astral-button>
        </div>
      }
    </astral-layout-group>
    @if (tenantCount > 1) {
      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <app-autocomplete-remote [control]="form.controls['tenantTwo']" [service]="dataService"></app-autocomplete-remote>
        @if (tenantTwoHasCivic) {
          <astral-input
            [label]="tenantTwoIdType"
            [value]="tenantTwoCivic"
            [readonly]="true"
            [helpText]="'TENANT.HELP_TEXT.OPEN_TENANT'"
          ></astral-input>
        }
        @if (tenantTwoHasPhone) {
          <astral-input
            label="TENANT.PHONE"
            [value]="tenantTwoPhone"
            [readonly]="true"
            [helpText]="'TENANT.HELP_TEXT.OPEN_TENANT'"
            [type]="'phone'"
            [inputMode]="'tel'"
          ></astral-input>
        }
        @if (tenantTwoHasEmail) {
          <astral-input [control]="tenantTwoEmailControl" [type]="'email'" [inputMode]="'email'"></astral-input>
        }
        @if (tenantTwoExist) {
          <div class="create-button astral-link-action astral-form-adjacent-action">
            <astral-button variant="link-button" type="button" labelKey="COMMON.OPEN_CONTACT" (click)="onOpenTenantTwoClicked()"></astral-button>
          </div>
        }
      </astral-layout-group>
    }
  </div>
}
